<div class="lds-roller" [ngClass]="{'app-spinner-small': small}"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>